// extracted by mini-css-extract-plugin
export default {"emailWrap":"email-subscribe_emailWrap__GOqPI","button":"email-subscribe_button__Z63MD"};